import { defineTheme } from 'vitepress-theme-async';
import layout from './layout.vue';

export default defineTheme({
	Layout: layout,
	enhanceApp({ app }) {
		//
	},
});
